import React from 'react';
import { Outlet } from 'react-router-dom';

import Footer from '@app/components/UI/Footer/Footer';
import Header from '@app/components/UI/Header/Header';

import '@app/scss/style.scss';

const LayoutMain: React.FC = () => {
	return (
		<div className="app-container">
			<Header />
			<Outlet />
			<Footer />
		</div>
	);
};

export default LayoutMain;
